import React, { useState, useEffect } from 'react';
import './Toast.css';

const Toast = ({ message, type, duration = 4000, onClose, style }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => {
        setIsVisible(false);
        onClose();
      }, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '!';
      default:
        return 'ℹ';
    }
  };

  const getIconColor = () => {
    switch (type) {
      case 'success':
        return '#10b981';
      case 'error':
        return '#ef4444';
      case 'warning':
        return '#f59e0b';
      default:
        return '#3b82f6';
    }
  };

  const getProgressColor = () => {
    switch (type) {
      case 'success':
        return '#10b981';
      case 'error':
        return '#ef4444';
      case 'warning':
        return '#f59e0b';
      default:
        return '#3b82f6';
    }
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`toast ${isExiting ? 'toast-exit' : ''}`}
      style={style}
    >
      <div className="toast-content">
        <div 
          className="toastad-icon"
          style={{ 
            backgroundColor: getIconColor(),
            color: 'white'
          }}
        >
          {getIcon()}
        </div>
        <div className="toastad-message">
          {message}
        </div>
        <button 
          className="toast-close"
          onClick={() => {
            setIsExiting(true);
            setTimeout(() => {
              setIsVisible(false);
              onClose();
            }, 300);
          }}
        >
          ×
        </button>
      </div>
      <div className="toast-progress">
        <div 
          className="toast-progress-bar"
          style={{ 
            backgroundColor: getProgressColor(),
            animationDuration: `${duration}ms`
          }}
        />
      </div>
    </div>
  );
};

export default Toast;